<h2>{{ 'task-templates.tasks' | translate }}</h2>
<section>
	@for (taskTemplate of taskTemplates; track taskTemplate) {
		<card>
			<task-template [taskTemplate]="taskTemplate" [taskTemplateTags]="taskTemplateTags" (removed)="removeTask(taskTemplate)"></task-template>
		</card>
	}
	<icon type="square-plus" (click)="addNewTask()" />
</section>
